import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    cardContent: {},
    root: {
        marginBottom: theme.spacing(6)
    },
    cardBannerWrapper: {
        position: 'relative',
        paddingBottom: 'calc(4 / 3 * 100%)',
        overflow: 'hidden',
        borderRadius: '4px',
        backgroundColor: '#282828' //theme.palette.grey[500]
    },
    cardBanner: {
        minHeight: '1px',
        width: '100%',

        '& img, & svg': {
            transition: 'opacity 125ms ease-in-out 450ms',
            position: 'absolute',
            height: '100%',
            width: '100%',
            opacity: 1
        }
    },
    cardMeta: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'space-between'
    },
    cardText: {
        letterSpacing: theme.typography.pxToRem(0.2),
        lineHeight: 1.4,
        fontWeight: 400,
        width: '80%'
    },
    cardLink: {
        paddingLeft: theme.spacing(1),
        paddingTop: '7px'
    },
    icon: {
        opacity: 0.2,
        cursor: 'pointer',

        '&:hover': {
            opacity: 1
        }
    },
    link: {
        transform: 'rotate(-45deg)'
    },
    withholdings: {
        opacity: 0.7
    }
}));

export default useStyles;
